import React from 'react';
import { FormSelect } from 'react-bootstrap';
import {
    FormEngineAdvancedFormSelect,
    FormEngineAdvancedFormSelectProps,
} from './advanced';
import classNames from '@form-engine/core-util/class-names';

export type FormEngineFormSelectProps = React.ComponentProps<
    typeof FormSelect
> &
    FormEngineAdvancedFormSelectProps & {
        advanced?: boolean;
    };

export default function FormEngineFormSelect({
    advanced,
    ...props
}: FormEngineFormSelectProps) {
    if (props.options || advanced) {
        return (
            <FormEngineAdvancedFormSelect
                {...props}
                className={classNames('fe-core-select', props.className)}
            />
        );
    }

    return <FormSelect {...props} />;
}

FormEngineFormSelect.Advanced = FormEngineAdvancedFormSelect;
